import AgencyReconciliationListView from 'features/Agency/components/AgencyReconciliationListView';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';

AgencyReconciliationListScreen.propTypes = {};

function AgencyReconciliationListScreen(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <AgencyReconciliationListView showFullUI={true} />
      </div>
    </KT01BaseLayout>
  );
}

export default AgencyReconciliationListScreen;
